import type DivisionRequestModel from 'ab-requestModels/division.requestModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

export function validate(values: DivisionRequestModel) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	return errors;
}
